import { postRequest } from 'features/common'
import settings from 'settings'

const { workspaceApiUrl } = settings

const TOKENS_URL = `${workspaceApiUrl}/tokens`
export const UPDATES_MARKDOWN_URL =
  'https://raw.githubusercontent.com/CartoDB/documentation/master/app/content/news-developers.md'

export const getUpdates = (): Promise<string> => {
  return fetch(UPDATES_MARKDOWN_URL).then((response) => response.text())
}

export const getLdsToken = async (): Promise<{ token }> => {
  // We do use upsert and it requires POST, not GET, but it's guaranteed to be stable after 1st generation
  return await postRequest(TOKENS_URL, {
    grants: [],
    referers: [],
    allowed_apis: ['lds'],
    upsertKey: 'LDS_FUNCTION'
  })
}
